import { render, staticRenderFns } from "./PaxImport.vue?vue&type=template&id=25fb7253&scoped=true&"
import script from "./PaxImport.vue?vue&type=script&lang=js&"
export * from "./PaxImport.vue?vue&type=script&lang=js&"
import style0 from "./PaxImport.vue?vue&type=style&index=0&id=25fb7253&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb7253",
  null
  
)

export default component.exports